import React, { forwardRef, useRef } from 'react';
import { Transition } from 'react-transition-group';
import PropTypes from 'prop-types';

/* Styles used for MenuSlide transition component */
const transitionStyles = {
    entering: {
        height: 0
    },
    entered: {
        height: 80
    }
};

/**
 * Custom transition component for the DesktopRankingTable more-info Menu which creates a slide down effect.
 * Ideally we would use MUI's own Collapse transition component here,
 * however this is currently affected by a bug which prevents its use for any Popover components:
 * https://github.com/mui/material-ui/issues/11337
 *
 * @type {React.ForwardRefExoticComponent<React.PropsWithoutRef<{}> & React.RefAttributes<unknown>>}
 */
export const MenuSlide = forwardRef((props, ref) => {
    const nodeRef = useRef(null);
    return (
        <Transition
            {...props}
            nodeRef={nodeRef}
            timeout={{ enter: 0, exit: 0 }}
        >
            {(state, childProps) => {
                return React.cloneElement(props.children, {
                    ...props.children.props,
                    style: {
                        ...transitionStyles[state],
                        transition: 'height 250ms ease-out',
                        overflow: 'hidden',
                        minHeight: 0,
                        ...props.children.props.style
                    },
                    ...childProps
                });
            }}
        </Transition>
    );
});

MenuSlide.displayName = 'MenuSlide';

MenuSlide.propTypes = {
    children: PropTypes.node
};
